/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ enabled: NonNullable<unknown>, max: NonNullable<unknown> }} Integrations_Usage_Counter_ValueInputs */



/**
* | output |
* | --- |
* | "{enabled}/{max}" |
*
* @param {Integrations_Usage_Counter_ValueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_usage_counter_value = /** @type {((inputs: Integrations_Usage_Counter_ValueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Usage_Counter_ValueInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.enabled}/${i?.max}`)
	return /** @type {LocalizedString} */ (`${i?.enabled}/${i?.max}`)
});